module.exports = __webpack_public_path__ + "static/media/7.33fc4ad4.jpg";